import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchThemaImportProgress } from "../api/themaImportService";
var POLL_INTERVAL = 2000;
var STORAGE_KEY_PREFIX = "thema-import-progress-";
var getCachedProgress = function (importId) {
    try {
        var cached = sessionStorage.getItem(STORAGE_KEY_PREFIX + importId);
        return cached ? JSON.parse(cached) : null;
    }
    catch (_a) {
        return null;
    }
};
var cacheProgress = function (importId, data) {
    try {
        sessionStorage.setItem(STORAGE_KEY_PREFIX + importId, JSON.stringify(data));
    }
    catch (_a) {
        /* empty */
    }
};
var isTerminal = function (status) {
    return status === "COMPLETED" || status === "FAILED";
};
export var useThemaImportProgress = function (importId) {
    var kyInstance = useOkapiKy();
    var cached = importId ? getCachedProgress(importId) : null;
    var progress = useQuery(["thema-import-progress", importId], function () { return fetchThemaImportProgress(kyInstance, importId); }, {
        enabled: !!importId && !(cached && isTerminal(cached.status)),
        initialData: cached !== null && cached !== void 0 ? cached : undefined,
        refetchInterval: function (data) {
            if (data && isTerminal(data.status)) {
                return false;
            }
            return POLL_INTERVAL;
        },
        onSuccess: function (data) {
            if (isTerminal(data.status)) {
                cacheProgress(importId, data);
            }
        },
    }).data;
    return progress !== null && progress !== void 0 ? progress : null;
};
